import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue';
import { usePaymentStore } from '@/store';
import { IDropdownItem, PaymentFrequency } from '@/interfaces';


export const emitPaymentFrequencyChanged = 'paymentFrequencyChanged';

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentFrequencyDropdown',
  props: {
    outerClass: {}
  },
  setup(__props: any) {

const props = __props;

const paymentStore = usePaymentStore();
const options = ref<IDropdownItem[]>();

onMounted(() => {
  if (paymentStore.paymentFrequencyWording) {
    options.value = [
      { label: paymentStore.paymentFrequencyWording?.monthly, value: paymentStore.paymentFrequencyWording?.monthly },
      { label: paymentStore.paymentFrequencyWording?.annual, value: paymentStore.paymentFrequencyWording?.annual },
    ];

    paymentStore.selectedPaymentFrequencyDisplayText =
      paymentStore.selectedPaymentFrequency == PaymentFrequency.Annually
        ? paymentStore.paymentFrequencyWording?.annual
        : paymentStore.paymentFrequencyWording?.monthly;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    key: `selectedPaymentFrequency-${_unref(paymentStore).selectedPaymentFrequencyDisplayText}`,
    modelValue: _unref(paymentStore).selectedPaymentFrequencyDisplayText,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(paymentStore).selectedPaymentFrequencyDisplayText) = $event)),
    name: "selectedPaymentFrequency",
    type: "racqDropdown",
    outerClass: _ctx.outerClass ?? 'mt-3 mb-6',
    classesOptions: "dropdown-sm text-m-bold",
    options: options.value
  }, null, 8, ["modelValue", "outerClass", "options"]))
}
}

})